import { Component, NgZone, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { AgRendererComponent } from 'ag-grid-angular';

@Component({
  selector: 'app-linktotfs',
  templateUrl: './linktotfs.component.html',
  styleUrls: ['./linktotfs.component.css'],
  encapsulation: ViewEncapsulation.None,
  // template:
  //   '<a [routerLink]="[params.inRouterLink,params.value]"  (click)="navigate(params.inRouterLink)">{{params.data.value}}</a>',
  // template: `
  //   <a href="{{params.data.LinktoTfs}}" target="_blank">
  //     <fa-icon [icon]="['fas', 'link']" class="link-icon"></fa-icon>
  //   </a>
  // `,
})
export class LinktotfsComponent implements AgRendererComponent {

  params: any;
  constructor(private ngZone: NgZone, private router: Router) {}

  agInit(params: any): void {
    this.params = params;
  }

  refresh(params: any): boolean {
    // const rowData = this.params.data; 
    // const url = rowData.LinktoTfs; // Assuming the URL is in a property called 'url'

    // window.open(url, '_blank'); 
    return false;
  }
  // This was needed to make the link work correctly
  navigate(link) {
    this.ngZone.run(() => {
      this.router.navigate([link, this.params.value]);
    });
  }
  onLinkClick(): void {
    const rowData = this.params.data; 
    const url = rowData.LinktoTfs;
    if ((rowData.LinktoTfs?.includes("https://")) || (rowData.LinktoTfs?.includes("http://"))) {
 // Assuming the URL is in a property called 'url'

      window.open(url, '_blank'); 
      //return `<a href="${params.value}" target="_blank" rel="noopener">${params.value}</a>`;
    }
    else {
      window.open("https://"+url+"", '_blank'); 
      //return `<a href="https://${params.value}" target="_blank" rel="noopener">${params.value}</a>`;
    }
    //const url = rowData.LinktoTfs; // Assuming the URL is in a property called 'url'

    //window.open(url, '_blank'); 
  }

}
